import Common from '../../../Common';


export interface UserPbxFlowItemValues {
	id?: id
	name?: string
	pbx_calendar_id?: id
}

export interface UserPbxFlowItemValuesObject {
	strategy?: string
	servicelevel?: string
	maxlen?: string
	pbx_queue_timeout?: string
}

export interface UserPbxFlowItem {
	id: id
	pbx_module_id: id
	pbx_destination_id: id
	name: string
	value: string
	values: UserPbxFlowItemValues[]
}

const Item = class extends Common {
	update = (userId: id, id: id, itemId: id, body: any) =>
		this.patch(`/user/${userId}/pbxflow/${id}/item/${itemId}`, body);
}

export default Item
